import { set as setCookie } from 'es-cookie';
import { readQuery } from '@/utils';

export function storeUTMparams() {
  const utm_source = readQuery('utm_source');
  const utm_medium = readQuery('utm_medium');
  const utm_campaign = readQuery('utm_campaign');
  const utm_term = readQuery('utm_term');
  const utm_content = readQuery('utm_content');

  if (utm_source) {
    setCookie('utm_source', utm_source + '', {
      expires: 365,
    });
  }

  if (utm_medium) {
    setCookie('utm_medium', utm_medium + '', {
      expires: 365,
    });
  }

  if (utm_campaign) {
    setCookie('utm_campaign', utm_campaign + '', {
      expires: 365,
    });
  }

  if (utm_term) {
    setCookie('utm_term', utm_term + '', {
      expires: 365,
    });
  }

  if (utm_content) {
    setCookie('utm_content', utm_content + '', {
      expires: 365,
    });
  }
}
